import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from '@/components/ui/button';
import { useElementSize } from '@/helpers/hooks';

const SignaturePad = ({ onSave }) => {
  const sigCanvas = useRef();
  const [containerRef, { width: containerWidth }] = useElementSize();
  const [isEmpty, setIsEmpty] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const clear = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
    setIsSaved(false);
  };

  const save = async () => {
    if (!isEmpty) {
      setIsSubmitting(true);
      const signatureImage = sigCanvas.current
        .getTrimmedCanvas()
        .toDataURL('image/png');
      await onSave(signatureImage);
      setIsSaved(true);
      setIsSubmitting(false);
    }
  };

  return (
    <div ref={containerRef} className="border rounded-md p-4">
      <SignatureCanvas
        ref={sigCanvas}
        canvasProps={{
          className: 'signature-canvas',
          width: containerWidth ? containerWidth - 32 : 400, // Subtracting padding
          height: 200
        }}
        onBegin={() => setIsEmpty(false)}
      />
      <div className="mt-4 flex justify-between">
        <Button onClick={clear} variant="outline" size="sm">
          Clear
        </Button>
        {!isSaved && (
          <Button onClick={save} disabled={isEmpty || isSubmitting} size="sm">
            Save Signature
          </Button>
        )}
      </div>
    </div>
  );
};

export default SignaturePad;
